import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Clock, FileText, PenLine, MapPin, LogOut, Shield, HelpCircle } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import Logo from '../common/Logo';
import { waSupport } from '../../utils/support';

const Navbar = () => {
  const location = useLocation();
  const { user, signOut, isAdmin } = useAuth();
  const firstName = user?.name ? user.name.split(' ')[0] : 'Usuário';

  const navigation = [
    { name: 'Dashboard', href: '/painel', icon: LayoutDashboard },
    { name: 'Meus Laudos', href: '/meus-laudos', icon: Clock },
    { name: 'Modelos', href: '/modelos', icon: FileText },
    { name: 'Assinaturas', href: '/assinaturas', icon: PenLine },
    { name: 'Locais', href: '/locais', icon: MapPin },
  ];

  return (
    <nav className="bg-navy border-b border-white/10 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 h-16 flex items-center justify-between">
        <div className="flex items-center gap-8">
          <Link to="/painel" className="flex items-center" aria-label="Laudando Online, painel"><Logo dark markClassName="h-9 w-9" /></Link>
          <div className="hidden lg:flex items-center gap-1">
            {navigation.map((item) => {
              const Icon = item.icon;
              const active = location.pathname === item.href;
              return <Link key={item.name} to={item.href} aria-current={active ? 'page' : undefined} className={`flex items-center gap-2 px-4 py-2 min-h-[44px] rounded-card text-sm font-medium transition-colors ${active ? 'text-white bg-white/10' : 'text-white/60 hover:text-white'}`}><Icon className="w-4 h-4" /><span>{item.name}</span></Link>;
            })}
          </div>
        </div>

        <div className="flex items-center gap-2 sm:gap-4">
          <a
            href={waSupport()}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center w-11 h-11 text-white/70 hover:text-white hover:bg-white/10 rounded-card transition-colors"
            title="Suporte do Laudando no WhatsApp"
            aria-label="Abrir suporte do Laudando no WhatsApp"
          >
            <HelpCircle className="w-5 h-5" aria-hidden="true" />
          </a>

          {isAdmin && <Link to="/admin" className="flex items-center gap-1.5 bg-white/10 text-white px-3 py-1.5 min-h-[44px] rounded-card text-[10px] font-semibold uppercase tracking-widest border border-white/15 hover:bg-white/20 transition-colors"><Shield className="w-3.5 h-3.5" /> Admin</Link>}

          <div className="flex items-center gap-3">
            <Link to="/perfil" className="hidden sm:flex items-center gap-2 min-h-[44px] group"><span className="text-sm font-semibold text-white hidden xl:block">{firstName}</span><span className="px-2 py-0.5 rounded bg-white/10 border border-white/15 text-white/80 text-[9px] font-semibold uppercase tracking-widest">{user?.plan_tier?.toUpperCase() || 'FREE'}</span></Link>
            <button onClick={signOut} className="p-2.5 min-h-[44px] min-w-[44px] text-white/60 hover:text-white transition-colors" title="Sair" aria-label="Sair da conta"><LogOut className="w-5 h-5" /></button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
